export { default } from './EmbeddedMap';
